<template>
  <div
    class="radio-card"
    :class="{
      colored: $props.colored,
      checked: $props.checked,
      disabled: $props.disabled,
    }"
    @click="!$props.disabled && $emit('change', $event.target.checked)"
  >
    <input type="radio" :name="$props.name" :checked="$props.checked" />
    <div class="radio-card__header">
      <slot name="header" />
      <div
        class="radio-card__radio"
        :class="{
          checked: $props.checked,
        }"
      />
    </div>
    <div class="radio-card__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioCard',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    colored: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'radio-card',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-card {
  border: none;
  width: 100%;
  padding: 0;
  background: white;
  cursor: pointer;
  border-radius: 12px;

  border: 1px solid rgba(224, 224, 224, 1);
  box-shadow: none;

  input {
    display: none;
  }

  .colored {
    border: none;
    box-shadow: 0px 1px 5px 0px rgba(31, 31, 31, 0.15);
  }

  &.disabled {
    cursor: not-allowed;
    .radio-card__header {
      background: #f2f2f2 !important;
    }
    ::v-deep {
      * {
        color: #8d8d8d !important;
      }
      .text-error {
        color: #e50505 !important;
      }
    }
  }

  &:nth-child(3n + 1) {
    &.colored {
      .radio-card__header {
        background: linear-gradient(90deg, #b7edb7 0%, #f5faf7 100%);
      }
    }
  }

  &:nth-child(3n + 2) {
    &.colored {
      .radio-card__header {
        background: linear-gradient(90deg, #fcdbb6 0%, #fcfaf7 100%);
      }
    }
  }

  &:nth-child(3n) {
    &.colored {
      .radio-card__header {
        background: linear-gradient(90deg, #d6e4fe 0%, #f7f8fa 100%);
      }
    }
  }

  &__header {
    background: rgba(247, 247, 247, 1);
    padding: 16px;
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__body {
    border-radius: 0 0 12px 12px;
    padding: 16px;
  }
  &__radio {
    border: 2px solid rgba(214, 214, 214, 1);
    width: 20px;
    height: 20px;
    border-radius: 9999px;
    flex-shrink: 0;
    &.checked {
      border: 6px solid rgba(43, 74, 199, 1);
    }
  }
  &.checked {
    outline: 2px solid rgba(43, 74, 199, 1);
  }
}
</style>
